import Highcharts from 'highcharts/highstock';
import { Highcharts as UnifyHighstockConfigurationTmp } from './Highcharts.js';

export class InitHighChart {
    initalize(brandedColors, colorScheme, exports) {
        window.Highcharts = Highcharts;
        exports = typeof exports !== 'undefined' ? exports : undefined;
        var unify = exports || {};

        unify.highcharts = new UnifyHighstockConfigurationTmp(brandedColors, colorScheme);

        // add highcharts to jquery (taken (slightly modified) from highcharts.src.js)
        window.jQuery.fn.highcharts = function () {
            var args = [].slice.call(arguments);
            if (this[0]) { // this[0] is the renderTo div
                // Create the chart
                if (args[0]) {
                    new window.Highcharts[ // eslint-disable-line no-new
                        // Constructor defaults to Chart
                        window.Highcharts.isString(args[0]) ? args.shift() : 'Chart'
                    ](this[0], args[0], args[1]);
                    return this;
                }
                // When called without parameters or with the return argument,
                // return an existing chart
                return window.Highcharts.charts[window.Highcharts.attr(this[0], 'data-highcharts-chart')];
            }
        };
    }
}